<template>
  <div ref="component" class="colorfff6 cx_style deng">
    <label
      v-if="title.length && titlePosition === 'singleLine'"
      class="font14 inlineMiddle mr8 singleLine text"
      ref="title"
      >{{ title }}</label
    >

    <div ref="box" :class="title.length && titlePosition === 'allInOneLine' ? 'verticallyCenter' : ''">
      <label
        v-if="title.length && titlePosition === 'allInOneLine'"
        class="font14 inlineMiddle mr12 allInOneLine text"
        ref="title"
        >{{ title }}</label
      >
      <div
        ref="colorPicker"
        :style="{ marginTop: titlePosition === 'allInOneLine' ? 0 : '8px', flex: 1 }"
        class="color-picker-container tooltip-bg-color inlineMiddle"
      >
        <el-color-picker v-model="colorVal" :show-alpha="true" :predefine="predefineColors" @active-change="activeChangeColor"></el-color-picker>
        <span class="text_color_in_input overflowHid percent80">{{ colorVal }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"
export default {
  mixins: [publicData],
  name: "colorPicker",
  props: {
    color: {
      type: null, //不传string 的原因是 在图表 单色 多色切换的时候 可能还没有获取到值 此时是undefined
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    titlePosition: {
      type: String,
      default: "allInOneLine"
    }
  },
  computed: {
    colorVal: {
      get() {
        return this.color
      },
      set(val) {
        this.$emit("change", val)
        this.$emit("update:color", val)
      }
    }
  },
  methods: {
    activeChangeColor(val) {
      this.colorVal = val
    }
  }
}
</script>

<style scoped>
.color_picker_flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.el-color-picker {
  width: 20px;
  height: 20px;
  left: 6px;
  right: 6px;
}
.text{
  color:var(--text)
}
</style>
